import EditDriverProducts from '../../components/drivers/EditDriverProducts'
import { connect } from 'react-redux'
import { IStoreState } from '../../types'
import { getSingleDriver } from '../../state/actions/drivers/'
import { getDriverById } from '../../state/reducers/drivers'
import { addProductsToDriver, removeProduct } from '../../state/actions/drivers'

export function mapStateToProps(state: IStoreState, ownProps: any) {
  const driverId = ownProps.match.params.id
  return {
    ...ownProps,
    organizationId: state.organizations.currentOrgId,
    loading: state.drivers.isSelectedDriverFetch || state.drivers.processing,
    id: driverId,
    allProducts: state.providerProduct.items,
    driver: getDriverById(state, driverId)
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getDriverInfo: (id: string) => dispatch(getSingleDriver(id)),
    addProductsToDriver: (driverId: string, productIds: string[], organizationId: string) =>
      dispatch(addProductsToDriver(driverId, productIds, organizationId)),
    removeProduct: (driverId: string, productId: string) => dispatch(removeProduct(driverId, productId))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditDriverProducts)



// WEBPACK FOOTER //
// ./src/containers/drivers/EditDriverProducts.ts